(function () {
  if (window.NumeoImageWithTextGalleryInitialized) return;
  window.NumeoImageWithTextGalleryInitialized = true;

  const DESKTOP_MEDIA_QUERY = window.matchMedia('(min-width: 750px)');

  function updateMediaRatio(galleryRoot, activeSlide) {
    const media = galleryRoot.querySelector('.image-with-text__media');
    if (!media) return;

    if (galleryRoot.dataset.galleryHeight !== 'adapt') return;

    const aspectRatio = parseFloat(activeSlide?.dataset.galleryAspectRatio || '');
    if (!Number.isFinite(aspectRatio) || aspectRatio <= 0) return;

    media.style.paddingBottom = `${(1 / aspectRatio) * 100}%`;
  }

  function syncTextHeight(galleryRoot) {
    if (!galleryRoot) return;

    const sectionRoot = galleryRoot.closest('.image-with-text-gallery');
    if (!sectionRoot) return;

    const media = galleryRoot.querySelector('.image-with-text__media');
    const textContent = sectionRoot.querySelector('.image-with-text__content');
    if (!media || !textContent) return;

    if (!DESKTOP_MEDIA_QUERY.matches) {
      textContent.style.removeProperty('--image-with-text-gallery-media-height');
      return;
    }

    textContent.style.setProperty('--image-with-text-gallery-media-height', `${media.offsetHeight}px`);
  }

  function syncAllGalleries(scope) {
    (scope || document).querySelectorAll('[data-image-with-text-gallery]').forEach((galleryRoot) => {
      syncTextHeight(galleryRoot);
    });
  }

  function setActiveImage(galleryRoot, target, initOnly) {
    const slides = Array.from(galleryRoot.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(galleryRoot.querySelectorAll('[data-gallery-thumb]'));
    if (!target || !slides.length || !thumbs.length) return;

    const activeSlide = slides.find((slide) => slide.dataset.gallerySlide === target);
    if (!activeSlide) return;

    slides.forEach((slide) => {
      const isActive = slide === activeSlide;
      slide.classList.toggle('is-active', isActive);
      slide.style.display = isActive ? 'block' : 'none';
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    thumbs.forEach((thumb) => {
      const isActive = thumb.dataset.galleryTarget === target;
      if (isActive) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });

    updateMediaRatio(galleryRoot, activeSlide);

    if (!initOnly) {
      const activeThumb = thumbs.find((thumb) => thumb.dataset.galleryTarget === target);
      activeThumb?.scrollIntoView({ inline: 'nearest', block: 'nearest' });
    }

    window.requestAnimationFrame(() => {
      syncTextHeight(galleryRoot);
    });
  }

  function getGalleryTargets(galleryRoot) {
    return Array.from(galleryRoot.querySelectorAll('[data-gallery-thumb]'))
      .map((thumb) => thumb.dataset.galleryTarget)
      .filter(Boolean);
  }

  function getCurrentTarget(galleryRoot) {
    const currentThumb = galleryRoot.querySelector('[data-gallery-thumb][aria-current="true"]');
    if (currentThumb?.dataset.galleryTarget) return currentThumb.dataset.galleryTarget;

    const activeSlide = galleryRoot.querySelector('[data-gallery-slide].is-active');
    if (activeSlide?.dataset.gallerySlide) return activeSlide.dataset.gallerySlide;

    const targets = getGalleryTargets(galleryRoot);
    return targets[0] || null;
  }

  function navigateGallery(galleryRoot, direction) {
    const targets = getGalleryTargets(galleryRoot);
    if (targets.length < 2) return;

    const currentTarget = getCurrentTarget(galleryRoot);
    let currentIndex = targets.indexOf(currentTarget);
    if (currentIndex < 0) currentIndex = 0;

    const nextIndex =
      direction === 'prev'
        ? (currentIndex - 1 + targets.length) % targets.length
        : (currentIndex + 1) % targets.length;

    setActiveImage(galleryRoot, targets[nextIndex], false);
  }

  function initGallery(galleryRoot) {
    if (!galleryRoot || galleryRoot.dataset.galleryInitialized === 'true') return;

    const thumbs = Array.from(galleryRoot.querySelectorAll('[data-gallery-thumb]'));
    if (!thumbs.length) return;

    galleryRoot.dataset.galleryInitialized = 'true';

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        setActiveImage(galleryRoot, thumb.dataset.galleryTarget, false);
      });
    });

    const initialThumb = thumbs.find((thumb) => thumb.hasAttribute('aria-current')) || thumbs[0];
    if (initialThumb) {
      setActiveImage(galleryRoot, initialThumb.dataset.galleryTarget, true);
    }
  }

  function initAllGalleries(scope) {
    (scope || document).querySelectorAll('[data-image-with-text-gallery]').forEach((galleryRoot) => {
      initGallery(galleryRoot);
      syncTextHeight(galleryRoot);
    });
  }

  window.addEventListener('resize', () => {
    syncAllGalleries();
  });

  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented) return;

      const prevButton = event.target.closest('[data-gallery-prev]');
      if (prevButton) {
        const galleryRoot = prevButton.closest('[data-image-with-text-gallery]');
        if (!galleryRoot) return;
        event.preventDefault();
        navigateGallery(galleryRoot, 'prev');
        return;
      }

      const nextButton = event.target.closest('[data-gallery-next]');
      if (nextButton) {
        const galleryRoot = nextButton.closest('[data-image-with-text-gallery]');
        if (!galleryRoot) return;
        event.preventDefault();
        navigateGallery(galleryRoot, 'next');
        return;
      }

      const thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb) return;

      const galleryRoot = thumb.closest('[data-image-with-text-gallery]');
      if (!galleryRoot) return;

      event.preventDefault();
      setActiveImage(galleryRoot, thumb.dataset.galleryTarget, false);
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => {
    initAllGalleries(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    syncAllGalleries();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllGalleries();
    });
  } else {
    initAllGalleries();
  }

  window.addEventListener('load', () => {
    syncAllGalleries();
  });
})();
